import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTextColor: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconTextColor"><Path d="M21.5 7.5C21.5 9.0464 20.1569 10.5 18.5 10.5C16.8431 10.5 15.5 9.0464 15.5 7.5C15.5 5.5 18.5 2.5 18.5 2.5C18.5 2.5 21.5 5.5 21.5 7.5Z" stroke="currentColor"/><Path d="M2.5 20.5L10 4.5L17.5 20.5" stroke="currentColor" strokeLinecap="square"/><Path d="M5.5 14.5H14.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconTextColor;
